import CustomDataTable from "components/shared/CustomDataTable";
import { CustomDropdown } from "components/shared/CustomDropdown";
import { IColumnModel } from "models/IColumnModel";
import { useEffect, useMemo, useState } from "react";
import { Col, Container, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import LocationService from "services/Location.Service";
import BrandMasterServices from "services/Master.Service";
import "./FindLocationDashboard.css";
import { downloadCSV, downloadMobileInvoice, findedLocation } from "../../helpers/Helper";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTypedSelector } from "features/reduxhooks/ReduxHooks";
import LocationRequestUAE from "components/LocationRequestUAE/LocationRequestUAE";
import LocationRequestIN from "components/LocationRequestIN/LocationRequestIN";
import CustomLoader from "components/Common/CustomLoader";
import StatusFilters from "components/filter/StatusFilters";
import { HelperConstant } from "../../helpers/HelperConstant";
import UseDebounce from "components/shared/UseDebounce";
import { Capacitor } from "@capacitor/core";
import StatusStatsFilters from "components/filter/StatusStatsFilters";

function FindLocationDashboard() {
    const [locationList, setLocationList] = useState<Array<any>>([]);
    const [selectedLocationData, setSelectedLocationData] = useState<any>();

    const [statusList, setStatusList] = useState<Array<any>>([]);
    const [ProductList, setProductList] = useState<Array<any>>([]);
    const [editModal, setEditModal] = useState(0);
    const [searchText, setSearchText] = useState<any>("");
    const [IsPublic, setIsPublic] = useState<boolean>(false);
    const [selectedColumn, setSelectedColumn] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [isStatusId, setIsStatusId] = useState("");
    const [isload, setIsLoad] = useState(false);
    const debouncedSearch = UseDebounce(searchText, 1000);
    const [fromDate, setFromDate] = useState<string | null>(null);
    const [toDate, setToDate] = useState<string | null>(null);

    const [rowsPerPage] = useState<number>(50);
    const [currentPage, setCurrentPage] = useState<any>(1);
    const [offsetStart, setOffsetStart] = useState<number>(0);

    const statusName = isStatusId ? statusList.filter(x => x.Id == isStatusId)[0]?.Name : HelperConstant.Request_For_Pickup_StatusEnums.Open;

    const IndiaColumns: IColumnModel[] = useMemo(() => [
        {
            Header: 'Created On',
            accessor: 'Created',
            width: "10%",
            displayInList: true,
            Filter: true,
            datatype: "date"
        },
        {
            Header: 'Location Code',
            accessor: 'LocationCode',
            Filter: true,
            displayInList: true,
            width: "10%",
            isSortable: true,
            datatype: "linkbtn"
        },
        {
            Header: 'Name',
            accessor: 'Name',
            width: "10%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'Mobile Number',
            accessor: 'MobileNumber',
            Filter: true,
            displayInList: true,
            width: "15%",
        },
        {
            Header: 'Gadget',
            accessor: 'ProductTypeName',
            width: "10%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'State',
            accessor: 'StateName',
            Filter: true,
            displayInList: true,
            width: "10%"
        },
        {
            Header: 'Zip Code',
            accessor: 'Zipcode',
            Filter: true,
            displayInList: true,
            width: "10%"
        },
        {
            Header: 'Status',
            accessor: 'StatusName',
            Filter: true,
            displayInList: true,
            width: "10%"
        },

    ], []);

    const UaeColumns: IColumnModel[] = useMemo(() => [
        {
            Header: 'Created On',
            accessor: 'Created',
            width: "10%",
            displayInList: true,
            Filter: true,
            datatype: "date"
        },
        {
            Header: 'Location Code',
            accessor: 'LocationCode',
            Filter: true,
            displayInList: true,
            width: "10%",
            isSortable: true,
            datatype: "linkbtn"
        },
        {
            Header: 'Name',
            accessor: 'Name',
            width: "10%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'Mobile Number',
            accessor: 'MobileNumber',
            Filter: true,
            displayInList: true,
            width: "15%",
        },
        {
            Header: 'Gadget',
            accessor: 'ProductTypeName',
            width: "10%",
            displayInList: true,
            Filter: true,
        },
        {
            Header: 'State',
            accessor: 'StateName',
            Filter: true,
            displayInList: true,
            width: "10%"
        },
        {
            Header: 'Status',
            accessor: 'StatusName',
            Filter: true,
            displayInList: true,
            width: "10%"
        },
    ], []);

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            StatusId: "",

        },
        validationSchema: Yup.object({
            StatusId: Yup.string().notRequired(),
        }),
        onSubmit(values) {
            console.log()
        }
    });

    const locationRequestData = (pagenumber: any, searchText: string, statusid: any, sortcolumn?: any, sortorder?: any) => {
        setIsLoad(true);
        getStatus()
        LocationService.GetLocationList({
            OffsetStart: offsetStart,
            RowsPerPage: rowsPerPage,
            SortOrder: "desc",
            SortOrderColumn: "modified",
            SearchText: searchText ? searchText : "",
            StatusId: statusid ? parseInt(statusid) : HelperConstant.Request_For_Pickup_StatusIds.Open,
            FromDate: fromDate,
            ToDate: toDate
        }).then(res => {
            if (res.status === 200) {
                setLocationList(res.data);
                setIsLoad(false);
            }
        }).catch((e: string) => {
            console.log(e);
        });
    }

    const getStatus = () => {
        LocationService.GetRequestPickupStats(HelperConstant.EntityTypeId.LOCATION_REQUEST).then(res => {
            if (res.status === 200) {
                setStatusList(res.data);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    useEffect(() => {
        locationRequestData(0, debouncedSearch, isStatusId);
    }, [offsetStart, rowsPerPage, isStatusId, fromDate, toDate]);


    const editHandler = (val) => {
        setEditModal(val.Id);
        setSelectedLocationData(val)
    }

    const searchHandler = (searchKeyword: any) => {
        setSearchText(searchKeyword);
        locationRequestData(0, searchKeyword, isStatusId);
    }

    const onColumnSortChange = (columnName, sortValue) => {
        setSelectedColumn(columnName);
        setSortOrder(sortValue);
        locationRequestData(0, debouncedSearch, isStatusId, columnName, sortValue)
    };

    const pagination = (pageNumber: any) => {
        locationRequestData(pageNumber, debouncedSearch, isStatusId, selectedColumn, sortOrder);
    }

    const getOrderPublicRequestExport = () => {
        setIsLoad(true);
        const fileName = `DOFY_RequestForPickUpList_${statusName}`;

        LocationService.GetOrderPublicRequestExport({
            SortOrder: "desc",
            SortOrderColumn: "modified",
            statusId: isStatusId ? parseInt(isStatusId) : HelperConstant.Request_For_Pickup_StatusIds.Open,
            searchText: debouncedSearch,
            FromDate: fromDate,
            ToDate: toDate
        }).then(res => {
            if (res.status === 200) {
                if (Capacitor.isNativePlatform()) {
                    let concatedBase64 = "data:application/octet-stream;base64, " + res.data;
                    downloadMobileInvoice(concatedBase64, fileName + ".xls");
                } else {
                    downloadCSV(res.data, fileName);
                }
                setIsLoad(false);
            }
        }).catch((e: string) => {
            console.log(e);
        });
    }

    // useEffect(() => {
    //     getStatus();
    // }, [])

    return (
        <div className="page-content">
            <CustomLoader isOpen={isload} />
            <Container fluid className="p-0">
                <div className="d-flex justify-content-between">
                    <h5 className="fw-semibold text-dofy dofy-admin-font-md" style={{ whiteSpace: "nowrap" }}>REQUEST FOR PICKUP</h5>
                </div>
                <StatusStatsFilters statusList={statusList} onClick={(id: any) => { setIsStatusId(id) }} statusName={statusName} onExport={getOrderPublicRequestExport} onFromDateChange={(value: any) => setFromDate(value)} onToDateChange={(value: any) => setToDate(value)} CreatedFromDateLabel="Created From Date" CreatedToDateLabel="Created To Date" />

                {/* <div className="grid-row">
                    <Col xl={4} lg={4} md={4} sm={12} xs={12}>
                    </Col>
                    <Col xl={4} lg={5} md={4} sm={12} xs={12}></Col>
                    <Col xl={4} lg={3} md={4} sm={12} xs={12} className='text-start'>
                        <CustomDropdown
                            label={"Filter By Status"}
                            id={"StatusId"}
                            name={"StatusId"}
                            value={formik.values.StatusId}
                            data={statusList}
                            displayField="Name"
                            valueField="Id"
                            touched={formik.touched.StatusId}
                            error={formik.errors.StatusId}
                            onChange={(e) => {
                                formik.handleChange(e);
                                setIsStatusId(e.target.value);
                                locationRequestData(0, searchText, e.target.value)
                            }}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.StatusId && formik.errors.StatusId ? true : false}
                            isMandatory={false} />
                    </Col>
                </div> */}
                <Row>
                    <Col xl={12}>
                        {locationList.length > 0 ?
                            <CustomDataTable data={locationList} columns={findedLocation().CountryCode == "in" ? IndiaColumns : UaeColumns}
                                isPagination={locationList[0]?.TotalRowsCount > 50 ? true : false}
                                customPageSize={50}
                                isActionEdit={false}
                                isActionDelete={false}
                                editHandler={undefined}
                                isGlobalFilter={true}
                                searchHandler={searchHandler}
                                onColumnSortChange={onColumnSortChange}
                                canShowButton1={false}
                                selectedPage={pagination}
                                canShowButton2={false}
                                deleteHandler={undefined}
                                createHandler={undefined}
                                path={''}
                                firstBtnName={''}
                                specialGrid={false}
                                recordsCount={locationList[0].TotalRowsCount}
                                pageSize={rowsPerPage}
                                linkBtnhandler={editHandler}
                                rowsPerPage={rowsPerPage}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                offsetStart={offsetStart}
                                setOffsetStart={setOffsetStart}
                            // sortOrder={[{
                            //     desc: false
                            // }]}
                            />
                            :
                            <CustomDataTable data={[]} columns={findedLocation().CountryCode == "in" ? IndiaColumns : UaeColumns}
                                isPagination={false}
                                customPageSize={undefined}
                                isActionEdit={true}
                                isActionDelete={false}
                                editHandler={undefined}
                                isGlobalFilter={true}
                                searchHandler={searchHandler}
                                canShowButton1={false}
                                canShowButton2={false}
                                deleteHandler={undefined}
                                createHandler={undefined}
                                path={''}
                                firstBtnName={''}
                                pageSize={rowsPerPage}
                                rowsPerPage={rowsPerPage}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                offsetStart={offsetStart}
                                setOffsetStart={setOffsetStart}
                            // recordsCount={locationList.length}
                            // sortOrder={[{
                            //     desc: true
                            // }]}
                            />
                        }


                    </Col>
                </Row>
                <Modal size='lg' isOpen={editModal > 0} centered>
                    <ModalHeader toggle={() => { setEditModal(0); locationRequestData(0, searchText, isStatusId) }}>
                        <div className=''>
                            <i className='fas fa-user-edit text-dofy me-2 font-size-15'></i>
                            <span className='font-size-16 fw-semibold text-dofy'>Location Request Edit</span>
                            {selectedLocationData?.LocationCode && (
                                <span className={`badge rounded-pill badge-soft-info font-size-8 fw-bolder px-2 pt-2`} style={{ marginLeft: '20px' }}>
                                    <p style={{ color: "#1e4495", fontWeight: 'bold', fontSize: '15px', marginBottom: '8px' }}>Code: {selectedLocationData.LocationCode}</p>
                                </span>
                            )}
                        </div>
                    </ModalHeader>
                    <ModalBody>
                        {findedLocation().CountryCode == "in" ?
                            <LocationRequestIN direction={""} language={"in_en"} Id={editModal} setEditModel={setEditModal} requestData={locationRequestData} selectedLocationData={selectedLocationData} statusId={isStatusId} statusList={statusList} />
                            :
                            <LocationRequestUAE direction={""} language={"in_en"} Id={editModal} setEditModel={setEditModal} requestData={locationRequestData} selectedLocationData={selectedLocationData} statusId={isStatusId} statusList={statusList} />
                        }
                    </ModalBody>
                </Modal>
            </Container >
        </div >
    )
}

export default FindLocationDashboard